import React, { Component } from 'react';
import WhiteLayout from '../template/WhiteLayout';

export default class Unauthorized extends Component {
	render() {
		return (
			<WhiteLayout>
				<React.Fragment>
					<div className="error-page">
						<h2 className="headline text-red">401</h2>

						<div className="error-content">
							<h3>
								<i className="fa fa-warning text-red" /> Ops! Você não tem acesso a essa função ou então
								não está logado no sistema.
							</h3>
							<p>
								retorne para o <a href="/login">login</a> e realize o acesso ao sistema.
							</p>
						</div>
					</div>
				</React.Fragment>
			</WhiteLayout>
		);
	}
}
